import { useMerchant } from 'hooks/useGlobalContext/useMerchant'
import React, { useEffect, useState } from 'react'
import { LoaderProps } from './types'
import { QUERY_MERCHANT_LOCATIONS, GET_STORES_BY_ID } from 'router/queries'
import { isAdmin, useSession } from 'packages/@slerp/accounts'
import { useQuery } from '@apollo/client'
import { MerchantLocation } from '@slerp/controls'

export const MerchantLocationsLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const { merchant, user } = useSession()
  const {
    merchantLocations,
    setMerchantLocations,
    setRefetchMerchantLocations
  } = useMerchant()
  const [isLoaded, setIsLoaded] = useState(false)

  const adminUser = isAdmin(user)

  const {
    loading: loadingMerchantLocations,
    refetch: refetchMerchantLocations
  } = useQuery<{
    merchants: { stores: MerchantLocation[] }[]
  }>(QUERY_MERCHANT_LOCATIONS, {
    variables: { slug: merchant?.slug },
    skip: !adminUser || !merchant?.slug || !!merchantLocations.length,
    onCompleted: (data) => {
      if (!data) {
        return
      }

      setMerchantLocations(data.merchants[0].stores)
    }
  })

  const storeIds = user?.stores?.map(({ store }) => store.id)

  const { loading: loadingStores, refetch: refetchStores } = useQuery(
    GET_STORES_BY_ID,
    {
      variables: { storeIds },
      skip: adminUser || !storeIds?.length || !!merchantLocations.length,
      onCompleted: (data) => {
        if (!data) {
          return
        }

        setMerchantLocations(data.stores)
      }
    }
  )

  useEffect(() => {
    setIsLoaded(isParentLoaded && !loadingMerchantLocations && !loadingStores)
  }, [loadingMerchantLocations, loadingStores, isParentLoaded])

  useEffect(() => {
    setRefetchMerchantLocations(() =>
      adminUser ? refetchMerchantLocations : refetchStores
    )
  }, [adminUser, refetchMerchantLocations, refetchStores])

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
